import { createFileRoute } from '@tanstack/react-router'
import { Card } from 'antd'
import { PageHeader } from '@/components/common/PageHeader'
import { requireAccess } from '@/app/router/route-guards'
import { UserRole } from '@/lib/rbac'

/** Example role-gated route (System Admin only). */
export const Route = createFileRoute('/_auth/system')({
  beforeLoad: () => requireAccess({ role: UserRole.SystemAdmin }),
  component: SystemSettingsPage,
})

function SystemSettingsPage() {
  return (
    <>
      <PageHeader title="System Settings" subtitle="Platform-wide configuration (placeholder)" />
      <Card>Only visible to System Admins.</Card>
    </>
  )
}
